import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiJsonFormatterComponent } from '@components/ui-json-formatter/ui-json-formatter.component';

@NgModule({
    imports: [
        CommonModule,
        ComponentSharedModule,
        MatIconModule,
    ],
    declarations: [
        UiJsonFormatterComponent,
    ],
    exports: [
        UiJsonFormatterComponent,
    ],
})
export class UiJsonFormatterModule { }
